import { DealerId } from '@upstart/harmony/lib/legos/dealerTypes';
import {
  PriceRules,
  PriceRulesMetadata,
} from '@upstart/harmony/lib/legos/priceRulesTypes';
import BackendService from './BackendService';

export default class DealerPriceRuleService {
  static get(dealerId: DealerId) {
    return BackendService.get(`/dealerPriceRules/${dealerId}`);
  }

  static update(
    dealerPriceRules: PriceRules & {
      metadata?: PriceRulesMetadata;
    },
  ) {
    return BackendService.put(`/dealerPriceRules/${dealerPriceRules.id}`, {
      body: dealerPriceRules,
    });
  }
}
